var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5530_4633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.935155 9.02153C1.07345 10.2553 2.07625 11.2348 3.3163 11.2946C4.1734 11.3358 5.04896 11.3573 5.99922 11.3573C6.94949 11.3573 7.82504 11.3358 8.68217 11.2946C9.9222 11.2348 10.925 10.2553 11.0633 9.02153C11.1564 8.19067 11.2329 7.33886 11.2329 6.47113C11.2329 5.60341 11.1564 4.7516 11.0633 3.92076C10.925 2.687 9.9222 1.70742 8.68217 1.6477C7.82504 1.60642 6.94949 1.58496 5.99922 1.58496C5.04896 1.58496 4.1734 1.60642 3.3163 1.6477C2.07625 1.70742 1.07345 2.687 0.935155 3.92076C0.842029 4.7516 0.765625 5.60341 0.765625 6.47113C0.765625 7.33886 0.84203 8.19067 0.935155 9.02153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07422 0.642578V2.81902",
    stroke: "#383838",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91797 0.642578V2.81902",
    stroke: "#383838",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8575 4.71406L1.14062 4.71405L1.27702 2.2026L5.94182 1.86426L10.8575 2.2026V4.71406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.935155 9.02153C1.07345 10.2553 2.07625 11.2348 3.3163 11.2946C4.1734 11.3358 5.04896 11.3573 5.99922 11.3573C6.94949 11.3573 7.82504 11.3358 8.68217 11.2946C9.9222 11.2348 10.925 10.2553 11.0633 9.02153C11.1564 8.19067 11.2329 7.33886 11.2329 6.47113C11.2329 5.60341 11.1564 4.7516 11.0633 3.92076C10.925 2.687 9.9222 1.70742 8.68217 1.6477C7.82504 1.60642 6.94949 1.58496 5.99922 1.58496C5.04896 1.58496 4.1734 1.60642 3.3163 1.6477C2.07625 1.70742 1.07345 2.687 0.935155 3.92076C0.842029 4.7516 0.765625 5.60341 0.765625 6.47113C0.765625 7.33886 0.84203 8.19067 0.935155 9.02153Z",
    stroke: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01562 4.71387H11.0335",
    stroke: "#383838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5530_4633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarActiveIcon);
export default __webpack_public_path__ + "static/media/CalendarActiveIcon.5b89266bf283298124c949bd78c815cc.svg";
export { ForwardRef as ReactComponent };